function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2771b8",
    d: "M 475.5,248.5 C 487.989,249.495 500.656,249.829 513.5,249.5C 513.194,246.615 513.527,243.948 514.5,241.5C 515.945,244.118 517.611,246.618 519.5,249C 527.827,249.5 536.16,249.666 544.5,249.5C 544.5,229.833 544.5,210.167 544.5,190.5C 536.167,190.5 527.833,190.5 519.5,190.5C 519.665,193.85 519.498,197.183 519,200.5C 517.204,197.073 515.037,193.906 512.5,191C 504.173,190.5 495.84,190.334 487.5,190.5C 487.666,196.176 487.499,201.843 487,207.5C 484.529,201.915 482.362,196.248 480.5,190.5C 463.83,190.333 447.163,190.5 430.5,191C 426.111,192.029 422.111,193.862 418.5,196.5C 417.534,194.604 417.201,192.604 417.5,190.5C 372.832,190.333 328.165,190.5 283.5,191C 282.005,194.817 280.505,198.65 279,202.5C 277.495,198.65 275.995,194.817 274.5,191C 264.506,190.5 254.506,190.334 244.5,190.5C 243.833,195.167 243.167,199.833 242.5,204.5C 240.793,199.882 238.793,195.382 236.5,191C 228.5,190.333 220.5,190.333 212.5,191C 207.871,201.093 203.371,211.259 199,221.5C 198.5,170.168 198.333,118.834 198.5,67.5C 322.167,67.5 445.833,67.5 569.5,67.5C 569.5,133.833 569.5,200.167 569.5,266.5C 494.833,266.333 420.166,266.5 345.5,267C 343.333,269.833 341.167,272.667 339,275.5C 336.833,272.667 334.667,269.833 332.5,267C 311.836,266.5 291.169,266.333 270.5,266.5C 270.5,286.167 270.5,305.833 270.5,325.5C 291.169,325.667 311.836,325.5 332.5,325C 334.34,322.331 336.34,319.831 338.5,317.5C 340.66,319.831 342.66,322.331 344.5,325C 357.162,325.5 369.829,325.667 382.5,325.5C 382.5,320.833 382.5,316.167 382.5,311.5C 388.545,311.697 394.545,311.363 400.5,310.5C 400.5,315.5 400.5,320.5 400.5,325.5C 408.833,325.5 417.167,325.5 425.5,325.5C 425.336,322.813 425.503,320.146 426,317.5C 428.285,319.907 430.451,322.407 432.5,325C 475.5,325.667 518.5,325.667 561.5,325C 564.196,324.235 566.696,323.068 569,321.5C 569.5,360.165 569.667,398.832 569.5,437.5C 445.833,437.5 322.167,437.5 198.5,437.5C 198.5,374.833 198.5,312.167 198.5,249.5C 204.5,249.5 210.5,249.5 216.5,249.5C 217.031,246.763 217.864,244.096 219,241.5C 226.33,238.706 230.83,241.04 232.5,248.5C 279.162,249.5 325.829,249.833 372.5,249.5C 372.335,246.482 372.502,243.482 373,240.5C 375.167,243.333 377.333,246.167 379.5,249C 392.162,249.5 404.829,249.667 417.5,249.5C 417.201,247.396 417.534,245.396 418.5,243.5C 421.383,246.109 424.717,247.942 428.5,249C 438.828,249.5 449.161,249.666 459.5,249.5C 460.031,246.763 460.864,244.096 462,241.5C 469.689,238.263 474.189,240.596 475.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6097cb",
    d: "M 244.5,190.5 C 244.666,196.176 244.499,201.843 244,207.5C 243.487,206.473 242.987,205.473 242.5,204.5C 243.167,199.833 243.833,195.167 244.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d73b9",
    d: "M 216.5,198.5 C 221.875,198.172 227.208,198.505 232.5,199.5C 238.371,213.407 244.371,227.24 250.5,241C 246.129,241.828 241.795,241.661 237.5,240.5C 236.399,238.358 235.399,236.192 234.5,234C 227.508,233.5 220.508,233.334 213.5,233.5C 212.833,236.167 212.167,238.833 211.5,241.5C 207.5,241.5 203.5,241.5 199.5,241.5C 204.89,227.055 210.556,212.721 216.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a72b8",
    d: "M 288.5,198.5 C 294.167,198.5 299.833,198.5 305.5,198.5C 305.5,212.833 305.5,227.167 305.5,241.5C 302.167,241.5 298.833,241.5 295.5,241.5C 295.666,231.494 295.5,221.494 295,211.5C 294.487,212.527 293.987,213.527 293.5,214.5C 290.04,223.34 287.04,232.34 284.5,241.5C 280.833,241.5 277.167,241.5 273.5,241.5C 270.702,232.438 267.702,223.438 264.5,214.5C 264.013,213.527 263.513,212.527 263,211.5C 262.5,221.494 262.334,231.494 262.5,241.5C 258.833,241.5 255.167,241.5 251.5,241.5C 251.5,227.167 251.5,212.833 251.5,198.5C 257.509,198.334 263.509,198.501 269.5,199C 273.052,207.654 276.219,216.487 279,225.5C 282.177,216.485 285.344,207.485 288.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a9cce",
    d: "M 288.5,198.5 C 294.31,197.51 300.31,197.177 306.5,197.5C 306.829,212.343 306.496,227.01 305.5,241.5C 305.5,227.167 305.5,212.833 305.5,198.5C 299.833,198.5 294.167,198.5 288.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2871b8",
    d: "M 349.5,207.5 C 341.167,207.5 332.833,207.5 324.5,207.5C 324.5,210.167 324.5,212.833 324.5,215.5C 332.5,215.5 340.5,215.5 348.5,215.5C 348.5,218.5 348.5,221.5 348.5,224.5C 340.5,224.5 332.5,224.5 324.5,224.5C 324.5,227.167 324.5,229.833 324.5,232.5C 332.833,232.5 341.167,232.5 349.5,232.5C 349.5,235.5 349.5,238.5 349.5,241.5C 337.5,241.5 325.5,241.5 313.5,241.5C 313.5,227.167 313.5,212.833 313.5,198.5C 325.5,198.5 337.5,198.5 349.5,198.5C 349.5,201.5 349.5,204.5 349.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b72b8",
    d: "M 355.5,198.5 C 365.506,198.334 375.506,198.5 385.5,199C 393.846,202.529 396.679,208.696 394,217.5C 391.815,221.857 388.315,224.69 383.5,226C 387.648,230.982 391.981,235.816 396.5,240.5C 392.205,241.661 387.871,241.828 383.5,241C 379.5,236.333 375.5,231.667 371.5,227C 369.866,226.506 368.199,226.34 366.5,226.5C 366.5,231.5 366.5,236.5 366.5,241.5C 362.833,241.5 359.167,241.5 355.5,241.5C 355.5,227.167 355.5,212.833 355.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2771b8",
    d: "M 399.5,198.5 C 403.167,198.5 406.833,198.5 410.5,198.5C 410.5,212.833 410.5,227.167 410.5,241.5C 406.833,241.5 403.167,241.5 399.5,241.5C 399.5,227.167 399.5,212.833 399.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f74b9",
    d: "M 428.5,198.5 C 435.5,198.5 442.5,198.5 449.5,198.5C 449.5,201.833 449.5,205.167 449.5,208.5C 444.156,208.334 438.823,208.501 433.5,209C 428.895,211.208 426.895,214.875 427.5,220C 427.86,228.856 432.527,233.023 441.5,232.5C 440.167,235.167 438.833,237.833 437.5,240.5C 429.445,243.053 423.278,240.719 419,233.5C 411.781,218.792 414.947,207.125 428.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d73b9",
    d: "M 460.5,198.5 C 465.544,198.173 470.544,198.506 475.5,199.5C 481.225,213.284 487.225,226.951 493.5,240.5C 489.167,241.833 484.833,241.833 480.5,240.5C 479.423,238.271 478.756,235.937 478.5,233.5C 471.492,233.334 464.492,233.5 457.5,234C 456.601,236.192 455.601,238.358 454.5,240.5C 450.555,241.491 446.555,241.824 442.5,241.5C 447.718,226.849 453.718,212.515 460.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#689bcd",
    d: "M 508.5,198.5 C 504.167,198.5 499.833,198.5 495.5,198.5C 495.5,212.833 495.5,227.167 495.5,241.5C 494.504,227.01 494.171,212.343 494.5,197.5C 499.363,197.181 504.03,197.514 508.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2871b8",
    d: "M 508.5,198.5 C 514.192,206.205 519.526,214.205 524.5,222.5C 524.783,223.289 525.283,223.956 526,224.5C 526.5,215.84 526.666,207.173 526.5,198.5C 529.833,198.5 533.167,198.5 536.5,198.5C 536.5,212.833 536.5,227.167 536.5,241.5C 532.154,241.666 527.821,241.499 523.5,241C 517.944,232.951 512.611,224.784 507.5,216.5C 507.217,215.711 506.717,215.044 506,214.5C 505.5,223.494 505.334,232.494 505.5,241.5C 502.167,241.5 498.833,241.5 495.5,241.5C 495.5,227.167 495.5,212.833 495.5,198.5C 499.833,198.5 504.167,198.5 508.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6d9ec",
    d: "M 526.5,198.5 C 526.666,207.173 526.5,215.84 526,224.5C 525.283,223.956 524.783,223.289 524.5,222.5C 525.167,214.5 525.833,206.5 526.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#669acd",
    d: "M 526.5,198.5 C 529.962,197.518 533.629,197.185 537.5,197.5C 537.829,212.343 537.496,227.01 536.5,241.5C 536.5,227.167 536.5,212.833 536.5,198.5C 533.167,198.5 529.833,198.5 526.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f8fb",
    d: "M 366.5,208.5 C 371.511,208.334 376.511,208.501 381.5,209C 384.462,212.488 383.795,215.155 379.5,217C 375.179,217.499 370.846,217.666 366.5,217.5C 366.5,214.5 366.5,211.5 366.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f8fb",
    d: "M 223.5,210.5 C 224.376,210.369 225.043,210.702 225.5,211.5C 227.038,215.407 228.704,219.24 230.5,223C 226.459,223.827 222.459,223.66 218.5,222.5C 220.182,218.474 221.848,214.474 223.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f5fa",
    d: "M 466.5,209.5 C 467.376,209.369 468.043,209.702 468.5,210.5C 470.167,214.5 471.833,218.5 473.5,222.5C 469.5,223.833 465.5,223.833 461.5,222.5C 463.766,218.366 465.432,214.033 466.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6d9ec",
    d: "M 264.5,214.5 C 263.833,223.5 263.167,232.5 262.5,241.5C 262.334,231.494 262.5,221.494 263,211.5C 263.513,212.527 264.013,213.527 264.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7daec",
    d: "M 295.5,241.5 C 294.833,232.5 294.167,223.5 293.5,214.5C 293.987,213.527 294.487,212.527 295,211.5C 295.5,221.494 295.666,231.494 295.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7cfe7",
    d: "M 349.5,207.5 C 341.684,208.492 333.684,208.826 325.5,208.5C 325.5,210.5 325.5,212.5 325.5,214.5C 333.352,214.175 341.018,214.508 348.5,215.5C 340.5,215.5 332.5,215.5 324.5,215.5C 324.5,212.833 324.5,210.167 324.5,207.5C 332.833,207.5 341.167,207.5 349.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6d9ec",
    d: "M 507.5,216.5 C 506.833,224.833 506.167,233.167 505.5,241.5C 505.334,232.494 505.5,223.494 506,214.5C 506.717,215.044 507.217,215.711 507.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7cfe7",
    d: "M 348.5,224.5 C 341.018,225.492 333.352,225.825 325.5,225.5C 325.5,227.5 325.5,229.5 325.5,231.5C 333.684,231.174 341.684,231.508 349.5,232.5C 341.167,232.5 332.833,232.5 324.5,232.5C 324.5,229.833 324.5,227.167 324.5,224.5C 332.5,224.5 340.5,224.5 348.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bed4e9",
    d: "M 514.5,241.5 C 513.527,243.948 513.194,246.615 513.5,249.5C 500.656,249.829 487.989,249.495 475.5,248.5C 487.833,248.5 500.167,248.5 512.5,248.5C 512.335,245.482 512.502,242.482 513,239.5C 513.717,240.044 514.217,240.711 514.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a72b8",
    d: "M 278.5,274.5 C 290.167,274.5 301.833,274.5 313.5,274.5C 313.5,277.833 313.5,281.167 313.5,284.5C 305.5,284.5 297.5,284.5 289.5,284.5C 289.5,286.833 289.5,289.167 289.5,291.5C 297.5,291.5 305.5,291.5 313.5,291.5C 313.5,294.5 313.5,297.5 313.5,300.5C 305.5,300.5 297.5,300.5 289.5,300.5C 289.5,303.167 289.5,305.833 289.5,308.5C 297.5,308.5 305.5,308.5 313.5,308.5C 313.5,311.5 313.5,314.5 313.5,317.5C 301.833,317.5 290.167,317.5 278.5,317.5C 278.5,303.167 278.5,288.833 278.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5d8eb",
    d: "M 328.5,274.5 C 323.968,274.182 319.634,274.515 315.5,275.5C 314.833,278.5 314.167,281.5 313.5,284.5C 313.5,281.167 313.5,277.833 313.5,274.5C 318.6,273.2 323.6,273.2 328.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c73b9",
    d: "M 328.5,274.5 C 331.787,278.959 335.287,283.292 339,287.5C 342.531,283.603 345.697,279.436 348.5,275C 353.167,274.333 357.833,274.333 362.5,275C 356.643,282.023 350.976,289.19 345.5,296.5C 350.842,303.197 356.175,309.864 361.5,316.5C 357.366,317.485 353.032,317.818 348.5,317.5C 345.175,313.531 341.841,309.531 338.5,305.5C 335.149,309.022 332.149,312.856 329.5,317C 324.833,317.667 320.167,317.667 315.5,317C 321.024,310.31 326.358,303.477 331.5,296.5C 326.143,289.481 320.809,282.481 315.5,275.5C 319.634,274.515 323.968,274.182 328.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c73b9",
    d: "M 375.5,304.5 C 374.515,308.634 374.182,312.968 374.5,317.5C 370.833,317.5 367.167,317.5 363.5,317.5C 363.5,303.167 363.5,288.833 363.5,274.5C 373.172,274.334 382.839,274.5 392.5,275C 402.142,278.114 405.642,284.614 403,294.5C 401.073,299.428 397.573,302.594 392.5,304C 386.843,304.499 381.176,304.666 375.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94b8db",
    d: "M 408.5,274.5 C 408.5,288.833 408.5,303.167 408.5,317.5C 412.167,317.5 415.833,317.5 419.5,317.5C 415.702,318.483 411.702,318.817 407.5,318.5C 407.171,303.657 407.504,288.99 408.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b73b9",
    d: "M 408.5,274.5 C 418.506,274.334 428.506,274.5 438.5,275C 447.474,279.298 449.974,286.132 446,295.5C 443.702,298.91 440.535,301.243 436.5,302.5C 441.019,307.184 445.352,312.018 449.5,317C 444.833,317.667 440.167,317.667 435.5,317C 431.5,312.333 427.5,307.667 423.5,303C 422.207,302.51 420.873,302.343 419.5,302.5C 419.5,307.5 419.5,312.5 419.5,317.5C 415.833,317.5 412.167,317.5 408.5,317.5C 408.5,303.167 408.5,288.833 408.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2771b8",
    d: "M 487.5,274.5 C 487.5,277.5 487.5,280.5 487.5,283.5C 479.316,283.174 471.316,283.508 463.5,284.5C 463.5,286.833 463.5,289.167 463.5,291.5C 471.5,291.5 479.5,291.5 487.5,291.5C 487.5,294.5 487.5,297.5 487.5,300.5C 479.5,300.5 471.5,300.5 463.5,300.5C 463.5,303.167 463.5,305.833 463.5,308.5C 471.5,308.5 479.5,308.5 487.5,308.5C 487.5,311.5 487.5,314.5 487.5,317.5C 475.833,317.5 464.167,317.5 452.5,317.5C 452.5,303.167 452.5,288.833 452.5,274.5C 464.167,274.5 475.833,274.5 487.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d73b9",
    d: "M 500.5,274.5 C 510.19,274.168 519.856,274.502 529.5,275.5C 528.167,278.167 526.833,280.833 525.5,283.5C 518.189,284.331 510.856,284.831 503.5,285C 502.065,287.267 502.398,289.267 504.5,291C 510.5,291.333 516.5,291.667 522.5,292C 530.878,296.953 532.711,303.786 528,312.5C 526.363,314.81 524.196,316.31 521.5,317C 511.839,317.5 502.172,317.666 492.5,317.5C 492.5,314.5 492.5,311.5 492.5,308.5C 500.507,308.666 508.507,308.5 516.5,308C 519.993,306.522 520.326,304.522 517.5,302C 511.833,301.667 506.167,301.333 500.5,301C 492.495,297.351 489.661,291.184 492,282.5C 494.074,278.923 496.907,276.256 500.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d73b9",
    d: "M 540.5,274.5 C 550.172,274.334 559.839,274.5 569.5,275C 567.467,277.896 566.134,281.063 565.5,284.5C 558.159,284.334 550.826,284.5 543.5,285C 542.065,287.267 542.398,289.267 544.5,291C 550.167,291.333 555.833,291.667 561.5,292C 569.859,297.026 571.692,303.86 567,312.5C 565.457,314.378 563.624,315.878 561.5,317C 551.839,317.5 542.172,317.666 532.5,317.5C 532.5,314.5 532.5,311.5 532.5,308.5C 540.174,308.666 547.841,308.5 555.5,308C 558.993,306.522 559.326,304.522 556.5,302C 551.167,301.667 545.833,301.333 540.5,301C 532.495,297.351 529.661,291.184 532,282.5C 534.074,278.923 536.907,276.256 540.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a9cce",
    d: "M 487.5,274.5 C 488.479,277.625 488.813,280.958 488.5,284.5C 480.167,284.5 471.833,284.5 463.5,284.5C 471.316,283.508 479.316,283.174 487.5,283.5C 487.5,280.5 487.5,277.5 487.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfd",
    d: "M 375.5,284.5 C 380.565,284.219 385.565,284.552 390.5,285.5C 393.377,288.64 393.043,291.307 389.5,293.5C 384.833,293.5 380.167,293.5 375.5,293.5C 375.5,290.5 375.5,287.5 375.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fafc",
    d: "M 419.5,284.5 C 424.511,284.334 429.511,284.501 434.5,285C 437.265,287.966 436.932,290.633 433.5,293C 428.845,293.499 424.179,293.666 419.5,293.5C 419.5,290.5 419.5,287.5 419.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1cbe5",
    d: "M 375.5,284.5 C 375.5,287.5 375.5,290.5 375.5,293.5C 380.167,293.5 384.833,293.5 389.5,293.5C 384.695,294.487 379.695,294.821 374.5,294.5C 374.187,290.958 374.521,287.625 375.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93b8db",
    d: "M 278.5,274.5 C 278.5,288.833 278.5,303.167 278.5,317.5C 290.167,317.5 301.833,317.5 313.5,317.5C 301.678,318.495 289.678,318.828 277.5,318.5C 277.171,303.657 277.504,288.99 278.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93b8db",
    d: "M 361.5,316.5 C 362.043,316.56 362.376,316.893 362.5,317.5C 357.682,318.812 353.015,318.812 348.5,317.5C 353.032,317.818 357.366,317.485 361.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97badc",
    d: "M 375.5,304.5 C 375.5,309.167 375.5,313.833 375.5,318.5C 371.298,318.817 367.298,318.483 363.5,317.5C 367.167,317.5 370.833,317.5 374.5,317.5C 374.182,312.968 374.515,308.634 375.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94b8db",
    d: "M 487.5,308.5 C 488.479,311.625 488.813,314.958 488.5,318.5C 476.322,318.828 464.322,318.495 452.5,317.5C 464.167,317.5 475.833,317.5 487.5,317.5C 487.5,314.5 487.5,311.5 487.5,308.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/americanExpress.c7850f76b970e73dfa50ff981459044e.svg";
export { ForwardRef as ReactComponent };